import { gsap } from 'gsap';
import { initials, enter } from '../animations';

export function gameEnter(el) {
  const scoreBg = el.querySelector('.game-score__bg');
  const scoreMt = el.querySelector('.game-score__mt');
  const circularEl = el.querySelector('.game-score__circular');
  const circularText = el.querySelector('.game-score__circular-text');
  const powerup = el.querySelector('.game-powerup-percentage');
  const circularLife = el.querySelector('.game-life__circle');
  const textLife = el.querySelector('.game-life__text');
  const tl = gsap.timeline();

  initials.get('fade')(scoreBg);
  initials.get('fade')(scoreMt);
  initials.get('circularButton')(circularEl);
  initials.get('fade')(circularText);
  initials.get('circularButton')(circularLife);
  initials.get('fade')(textLife);
  gsap.set(powerup, { scale: 0, transformOrigin: '50% 50%' });

  tl.addLabel('start')
    .add(enter.get('fade')(scoreBg), 'start')
    .add(enter.get('fade')(scoreMt, 5), 'start+=0.3')
    .add(enter.get('circularButton')(circularEl), 'start+=0.5')
    .add(enter.get('fade')(circularText, 5), 'start+=0.6')
    .add(enter.get('circularButton')(circularLife), 'start+=0.5')
    .add(enter.get('fade')(textLife, 5), 'start+=0.6')
    .to(powerup, { scale: 1, ease: 'bloom', duration: 1.5 }, 'start+=0.3');

  return tl;
}

export function gameLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, translateY: -20, ease: 'bloom' });

  return tl;
}
